import { getFoundationConcreteVolume as t } from "./index22.js";
const r = (e) => t(e) * 175;
export {
  r as getFoundationSteelWeight
};
//# sourceMappingURL=index24.js.map
